import { Log, RouteSelectionMode } from '@/types/logs'

interface CommonInformation extends Pick<Log, 'trip' | 'run'> {
    description: string
    baseDepot: string
    routes: string
    duty: string
    fleet: string
}

export const getLogCommonInformation = (log: Log): CommonInformation => ({
    description: log.descriptionInfo.description,
    baseDepot: log.garageCode || '',
    duty: log.duty ? log.duty.join('/') : '',
    routes:
        log.routeSelectionMode === RouteSelectionMode.None
            ? '-'
            : log.routeSelectionMode === RouteSelectionMode.All
              ? 'N/A'
              : log.routes?.join(', '),
    run: log.run,
    fleet: log.fleet ? log.fleet.join('/') : '',
    trip: log.trip
        ? `${log.trip}${log.rtnTrips.length ? `/${log.rtnTrips.map((trip) => trip.trip).join(',')}` : ''}`
        : '',
})
